import React, { Component } from 'react';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import SubcourseCollapsable from './SubcourseCollapsable'
import { Alert, Col, FormGroup, Input, Button } from "reactstrap";
import { PulseLoader } from "react-spinners";
import forOwn from 'mout/object/forOwn'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import { connect } from 'react-redux'
import { courses } from '../../../../redux/actions/courses'

const SubcourseItem = sortableElement(
  ({ value, toggle, toggleCards, index, toggleValue, items, addSubcourse, reArrangeSubcourse, onSortEnd, indexUpdate, toggleSubcourseStatus }) => <SubcourseCollapsable toggleSubcourseStatus={toggleSubcourseStatus} indexUpdate={indexUpdate} onSortEnd={onSortEnd} reArrangeSubcourse={reArrangeSubcourse} addSubcourse={addSubcourse} lastItem={items} toggleCard={toggleValue !== index} toggleCards={toggleCards} toggle={toggle} index={index} value={value} />);
const SubCourseContainer = sortableContainer(({ children }) => {
  return <span>{children}</span>;
});



class AuthorCollapsable extends Component {
  state = {
    items: [],
    error: "",
    isFetching: false,
    toggle: true,
    toggleValue: "",
    addSubcourse: false,
    diff: [],
    name : ''
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.addSubcourse !== prevState.addSubcourse) {
      let addSubcoursesection = document.querySelector('.scroll-to-subcourse');
      addSubcoursesection && addSubcoursesection.scrollIntoView({ behavior: 'smooth' })
    }

    if((prevProps.courses.togglePublishStatus !== this.props.courses.togglePublishStatus) || (this.props.courses.deletingSubcourse !== prevProps.courses.deletingSubcourse) ){
      const { courses } = this.props;
      const { course, subcourses } = courses;
      let items = []
      forOwn(course.subcourses, function (val, key) {
        subcourses.forEach(subcourse => {
  
          if (subcourse.id === key) {
            let obj = {
              ...subcourse,
              index: val
            }
            items.push(obj);
          }
        })
      })
      this.setState({ items: sortByPropText(items, 'index') })
    }
 


  }

  componentDidMount() {
    const { courses } = this.props;
    const { course, subcourses } = courses;
    let items = []
    forOwn(course.subcourses, function (val, key) {
      subcourses.forEach(subcourse => {

        if (subcourse.id === key) {
          let obj = {
            ...subcourse,
            index: val
          }
          items.push(obj);
        }
      })
    })
    this.setState({ items: sortByPropText(items, 'index') })
  }


  indexUpdate = (id, index) => {
    this.setState(state => {
      let arr = Array.from(state.diff)
      arr.push({ id, index })
      return { diff: arr }
    })
  }

  reArrangeSubcourse = () => {
    this.setState(state => ({ reArrangeSubcourse: !state.reArrangeSubcourse }))
    this.setState({ toggle: !this.state.toggle })
  }


  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
    if(this.state.diff.length > 0 ) {
      this.props.updateIndexSubCourse(this.props.match.params.courseId, this.state.diff)
      this.setState({ diff : []  })
    }

  };

  shouldCancelStart = () => {
    if (this.state.toggle) return false;
  };

  toggleSubCourses = () => {
    this.setState({ toggle: !this.state.toggle, toggleValue: "" });
  };

  addSubcourse = () => {
    this.setState(state => ({ addSubcourse: !state.addSubcourse }));
  };

  toggleCards = value => {
    this.setState({ toggleValue: value, toggle: !this.state.toggle });
  };

  submit = () => {
    const { courses } = this.props;
    let subcourse = {
      courseId: courses.course.id,
      name: this.state.name,
      displayName: this.state.name
    }
    this.props.createSubcourse(subcourse, courses.course)

  }

  handleChange = (e) => {
    this.setState({ name: e.target.value })
  }



  render() {
    const { courses } = this.props;
    const { addSubcourse, reArrangeSubcourse, items } = this.state;


    return (
      <SubCourseContainer helperClass={'draggable-helper'} lockAxis={'y'} useDragHandle shouldCancelStart={this.shouldCancelStart} distance={1} onSortEnd={this.onSortEnd}>
        {
          courses.subcourses.length === 0 && <Alert
            color="danger"
          >{`No Subcourses`}</Alert>
        }
      

        <div className="edit-course-panel">
          {courses.subcourses.length > 0 && <span className={`${reArrangeSubcourse ? 'active' : ''}`} onClick={this.reArrangeSubcourse}>Rearrange Subcourses</span>}
          <div onClick={this.addSubcourse}>+ Add New Subcourse</div>
        </div>

        {items.length > 0 && items.map((value, index) => (
          <SubcourseItem toggleSubcourseStatus={this.props.toggleSubcourseStatus} indexUpdate={this.indexUpdate} reArrangeSubcourse={reArrangeSubcourse} items={courses.subcourses.length} addSubcourse={addSubcourse} toggleValue={this.state.toggleValue} onSortEnd={this.onSortEnd} toggleCards={this.toggleCards} toggle={this.state.toggle} key={`item-${index}`} index={index} value={value} />
        ))}
        {addSubcourse && <Col xs={12} md={4} className="scroll-to-subcourse new-item-section">
          <Col className="p-0 subcourse-head">Add new Subcourse</Col>
          <FormGroup row>
            <Col sm="9"><Input value={this.state.name} onChange={this.handleChange} placeholder={'Enter Subcourse Name ..'} /></Col>
            <Col sm="3" className="pl-0">
              <Button onClick={this.submit} disabled={this.state.name === ''} className="w-100">{courses.creatingSubcourse ? <div className="m-auto"><PulseLoader loading color={'#fff'} size={10} /></div> : 'Save'}</Button>
            </Col>
          </FormGroup>
        </Col>}

      </SubCourseContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    courses: state.courses
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateIndexSubCourse: (courseId, indexes) => { dispatch(courses.updateIndexSubCourse(courseId, indexes)) },
    toggleSubcourseStatus: (subcourseId, status) => { dispatch(courses.toggleSubcourseStatus(subcourseId, status)) }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(AuthorCollapsable)


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorCollapsable/index.js